import { RouteType } from "./config";
import CarRental from "../pages/carrental/CarRental";
import ReservationAttempts from "../pages/carrental/ReservationAttempts";
import Calendar from "../pages/carrental/calendar/Calendar";
import Fleet from "../pages/fleet/Fleet";
import Contacts from "../pages/contacts/Contacts";
import Fires from "../pages/forms/Fires";
import Checklist from "../pages/checklist/Checklist";
import Forms from "../pages/forms/Forms";
import Reports from "../pages/reports/Reports";
import { DailyNotes } from "../pages/dailyNotes/DailyNotes";
import { Dashboard } from "../pages/dashboard/Dashboard";
import { Quotes } from "../pages/carrental/quotes/Quotes";
import { Vehicles } from "../pages/fleet/vehicles/Vehicles";
import { Reservations } from "../pages/carrental/reservations/Reservations";
import { Maintenance } from "../pages/fleet/maintenance/Maintenance";
import { RepairOrders } from "../pages/fleet/repairOrder/RepairOrders";
import { Customers } from "../pages/contacts/customers/Customers";
import { CustomersEnquiry } from "../pages/contacts/customersEnquiry/CustomersEnquiry";
import { Payments } from "../pages/carrental/payments/Payments";
import { Vendors } from "../pages/vendorsManagement/Vendors";
import VendorsManagement from "../pages/vendorsManagement/VendorsManagement";


export const appRoutes: RouteType[] = [
  {
    index: true,
    path: "/dashboard",
    element: <Dashboard />,
    state: "dashboard",
    section: "Dashboard",
    sidebarProps: {
      displayText: "Dashboard",
      icon: 'dashboard',
    },
  },
  {
    path: "/carrental",
    element: <CarRental />,
    state: "carrental",
    sidebarProps: {
      displayText: "Car Rental",
      icon: 'stacks',
    },
    child: [
      {
        path: "/carrental/reservations",
        element: <Reservations />,
        state: "carrental.reservations",
        section: "dashboardreservations",
        sidebarProps: {
          displayText: "Reservations",
        },
      },
      {
        path: "/carrental/reservationattempts",
        element: <ReservationAttempts />,
        state: "carrental.reservationsattempts",
        section: "dashboardreservationattempts",
        sidebarProps: {
          displayText: "Reservation Attempts",
        },
      },
      {
        path: "/carrental/quotes",
        element: <Quotes />,
        state: "carrental.quotes",
        section: "dashboardquotes",
        sidebarProps: {
          displayText: "Quotes",
        },
      },
      {
        path: "/carrental/payments",
        element: <Payments />,
        state: "carrental.payments",
        section: "dashboardpayments",
        sidebarProps: {
          displayText: "Payments",
        },
      },
      {
        path: "/carrental/calendar",
        element: <Calendar />,
        state: "carrental.calendar",
        section: "dashboardcalendar",
        sidebarProps: {
          displayText: "Calendar",
        },
      },
    ],
  },
  {
    path: "/fleet",
    element: <Fleet />,
    state: "fleet",
    sidebarProps: {
      displayText: "Fleet",
      icon: 'directions_car',
    },
    child: [
      {
        path: "/fleet/vehicle",
        element: <Vehicles />,
        state: "fleet.vehicles",
        section: "dashboardvehicles",
        sidebarProps: {
          displayText: "Vehicles",
        },
      },
      {
        path: "/fleet/maintenance",
        element: <Maintenance />,
        state: "fleet.maintenance",
        section: "dashboardmaintenance",
        sidebarProps: {
          displayText: "Maintenance",
        },
      },
      {
        path: "/fleet/repairorders",
        element: <RepairOrders />,
        state: "fleet.repairorders",
        section: "dashboardrepairorders",
        sidebarProps: {
          displayText: "Repair Orders",
        },
      },
    ],
  },
  {
    path: "/contacts",
    element: <Contacts />,
    state: "contacts",
    sidebarProps: {
      displayText: "Contacts",
      icon: 'group',
    },
    child: [
      {
        path: "/contacts/customers",
        element: <Customers />,
        state: "contacts.Customers",
        section: "dashboardcustomers",
        sidebarProps: {
          displayText: "Customers",
        },
      },
      {
        path: "/contacts/CustomersEnquiry",
        element: <CustomersEnquiry />,
        state: "contacts.CustomersEnquiry",
        section: "dashboardcustomersenquiry",
        sidebarProps: {
          displayText: "Customers Enquiry",
        },
      }
    ],
  },
  {
    path: "/vendorsmanagement",
    element: <VendorsManagement />,
    state: "vendorsmanagement",
    sidebarProps: {
      displayText: "Vendor Mgmt",
      icon: 'storefront',
    },
    child: [
      {
        path: "/vendorsmanagement/vendors",
        element: <Vendors />,
        state: "vendorsmanagement.vendors",
        section: "dashboardvendors",
        sidebarProps: {
          displayText: "Vendors",
        },
      }
    ],
  },
  {
    path: "/checklist/checklist",
    element: <Checklist />,
    state: "checklist.checklist",
    section: "dashboardchecklist",
    sidebarProps: {
      displayText: "Checklist",
      icon: 'select_check_box',
    },
  },
  {
    path: "/forms",
    element: <Forms />,
    state: "forms",
    sidebarProps: {
      displayText: "Forms",
      icon: 'news',
    },
    child: [
      {
        path: "/forms/fires",
        element: <Fires />,
        state: "forms.fires",
        section: "dashboardfires",
        sidebarProps: {
          displayText: "Fires",
        },
      },
    ],
  },
  {
    path: "/reports",
    element: <Reports />,
    state: "reports",
    section: "dashboardreports",
    sidebarProps: {
      displayText: "Reports",
      icon: 'insert_chart',
    },
  },
  {
    path: "/daily-notes",
    element: <DailyNotes />,
    state: "dailynotes",
    section: "dashboardnotes",
    sidebarProps: {
      displayText: "Daily Notes",
      icon: "edit_note",
    },
  },
];

export default appRoutes;